export default "__VITE_ASSET__UpvXpdiF__"